import IconHelper from "./IconHelper";

const DigitalTurbineLogoIcon = (props) => {
  return (
    <IconHelper {...props} defaultWidth={32} defaultHeight={32}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.9601 7.19999C10.6226 7.86265 8.88606 9.95468 8.75469 12.4717C7.94187 11.5119 7.45166 10.2702 7.45166 8.91395C7.45166 5.87174 9.91787 3.40552 12.9601 3.40552V7.19999Z"
          fill="#FFA500"
        />
        <path
          d="M10.6014 16.3623C12.9389 15.6996 14.6755 13.6076 14.8068 11.0905C15.6197 12.0504 16.1099 13.2921 16.1099 14.6483C16.1099 17.6905 13.6437 20.1567 10.6014 20.1567V16.3623Z"
          fill="#CC0E93"
        />
        <path
          d="M16.3623 12.9606C15.6996 10.6231 13.6076 8.88654 11.0905 8.75518C12.0504 7.94236 13.2921 7.45215 14.6483 7.45215C17.6905 7.45215 20.1567 9.91836 20.1567 12.9606L16.3623 12.9606Z"
          fill="#F04C0A"
        />
        <path
          d="M7.19975 10.6019C7.8624 12.9394 9.95443 14.676 12.4715 14.8073C11.5117 15.6201 10.2699 16.1103 8.91371 16.1104C5.8715 16.1104 3.40527 13.6441 3.40527 10.6019L7.19975 10.6019Z"
          fill="#8336D6"
        />
      </svg>
    </IconHelper>
  );
};

export default DigitalTurbineLogoIcon;
